module.exports = __webpack_public_path__ + "img/icon_exercises_img.a117dc79.png";